import axios from "axios";

export const fetchCompanies = (width, window, token, id, parseData) => {
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_VERSION + 'dropdowns/companies',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    axios(config)
        .then(function (response) {
            // console.log(response);
            const data = [];
            response.data.data.forEach(r => {
              data.push({
                value: r['id'],
                label: r['text'],
              });
            });
            parseData(data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const fetchCompanyBranches = (width, window, token, id, company_id, parseData) => {
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_VERSION + 'dropdowns/company-branches?company_id=' + company_id,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    axios(config)
        .then(function (response) {
            // console.log(response);
            const data = [];
            response.data.data.forEach(r => {
              data.push({
                value: r['id'],
                label: r['text'],
              });
            });
            parseData(data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const fetchAgents = (width, window, token, id, parseData) => {
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_VERSION + 'dropdowns/agents',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    axios(config)
        .then(function (response) {
            // console.log(response);
            const data = [];
            response.data.data.forEach(r => {
              data.push({
                value: r['id'],
                label: r['text'],
              });
            });
            parseData(data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const fetchPos = (width, window, token, id, parseData) => {
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_VERSION + 'dropdowns/pos',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    axios(config)
        .then(function (response) {
            // console.log(response);
            const data = [];
            response.data.data.forEach(r => {
              data.push({
                value: r['id'],
                label: r['text'],
              });
            });
            parseData(data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const fetchBuses = (width, window, token, id, parseData) => {
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_VERSION + 'dropdowns/buses',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    axios(config)
        .then(function (response) {
            // console.log(response);
            const data = [];
            response.data.data.forEach(r => {
              data.push({
                value: r['id'],
                label: r['text'],
              });
            });
            parseData(data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const fetchRoutes = (width, window, token, id, parseData) => {
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_VERSION + 'dropdowns/routes',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    axios(config)
        .then(function (response) {
            // console.log(response);
            const data = [];
            response.data.data.forEach(r => {
              data.push({
                value: r['id'],
                label: r['text'],
              });
            });
            parseData(data);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const fetchRouteDestinations = (width, window, token, id, route_id, parseData) => {
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_VERSION + 'dropdowns/destinations?company_id=' + route_id,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    axios(config)
        .then(function (response) {
            // console.log(response);
            const data = [];
            response.data.data.forEach(r => {
              data.push({
                value: r['id'],
                label: r['text'],
              });
            });
            parseData(data);
        })
        .catch(function (error) {
            console.log(error);
        });
}